/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_Pro_IncludesInputs */



/**
* | output |
* | --- |
* | "Everything in Starter, and:" |
*
* @param {Signup_Plan_Pro_IncludesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_pro_includes = /** @type {((inputs?: Signup_Plan_Pro_IncludesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_Pro_IncludesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "de") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Everything in Starter, and:")
	return /** @type {LocalizedString} */ ("Everything in Starter, and:")
});